import './RequiredIndicator.css'

export const RequiredIndicator = () => {
  return (
    <span className="required-indicator" aria-hidden="true">
      *
    </span>
  )
}
